import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("customer_insights.label.visitor_presentation"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _vm.canUpload
            ? _c(
                "template",
                { slot: "description" },
                [
                  _c(VBreadcrumbs, {
                    staticClass: "pa-0 mb-3",
                    attrs: { items: _vm.getBreadcrumbs },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "customer_insights.label.visitor_presentation_sub"
                        )
                      ) +
                      " "
                  ),
                ],
                1
              )
            : _c(
                "template",
                { slot: "description" },
                [
                  _c(VBreadcrumbs, {
                    staticClass: "pa-0",
                    attrs: { items: _vm.getBreadcrumbs },
                  }),
                ],
                1
              ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _vm.canUpload
              ? _c(
                  VRow,
                  { attrs: { justify: "center" } },
                  [
                    _c(
                      VCol,
                      {
                        staticClass: "col-md-12 col-xl-10 col-12",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          VContainer,
                          { attrs: { fluid: "" } },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "" } },
                              _vm._l(_vm.cards, function (card) {
                                return _c(
                                  VCol,
                                  {
                                    key: card.title,
                                    staticClass: "pr-3 pl-3 mb-6",
                                    attrs: { cols: "12", md: card.flex, sm: 6 },
                                  },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        staticClass: "mx-auto",
                                        attrs: { "max-width": "344" },
                                      },
                                      [
                                        _c(
                                          VListItem,
                                          [
                                            _c(
                                              VListItemContent,
                                              {
                                                staticClass:
                                                  "text-center align-center",
                                              },
                                              [
                                                _c(
                                                  VListItemTitle,
                                                  { staticClass: "headline" },
                                                  [_vm._v(_vm._s(card.title))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(VImg, {
                                          attrs: {
                                            src: require("@/assets/icons/" +
                                              card.src),
                                            height: "194",
                                          },
                                        }),
                                        _c(
                                          VCardText,
                                          { staticClass: "text-center" },
                                          [
                                            _c("div", {
                                              domProps: {
                                                textContent: _vm._s(card.texto),
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                            _c(
                              VRow,
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12 text-right mt-2" } },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "primary",
                                        on: { click: _vm.OnStart },
                                      },
                                      [_vm._v("Empezar")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("report-list"),
          ],
          1
        ),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_VISITOR_PRESENTATION,
        attrs: {
          title: _vm.$t("customer_insights.label.visitor_presentation"),
          "show-buttons": false,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c(
                      VContainer,
                      [
                        _c(
                          VForm,
                          {
                            ref: "form_presentation",
                            attrs: { "lazy-validation": "" },
                            model: {
                              value: _vm.valid,
                              callback: function ($$v) {
                                _vm.valid = $$v
                              },
                              expression: "valid",
                            },
                          },
                          [
                            _c(
                              VRow,
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(VSelect, {
                                      staticClass: "mr-1",
                                      attrs: {
                                        label: _vm.$t(
                                          "customer_insights.label.organization"
                                        ),
                                        name: "id_organization",
                                        placeholder: _vm.$t(
                                          "customer_insights.label.organization"
                                        ),
                                        items: _vm.organizationsList,
                                        rules: _vm.rules.organization,
                                        "item-value": "id_organization",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      on: { change: _vm.changeOrganization },
                                      model: {
                                        value: _vm.organization_id,
                                        callback: function ($$v) {
                                          _vm.organization_id = $$v
                                        },
                                        expression: "organization_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.mostrarBrands
                                  ? _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(VSelect, {
                                          staticClass: "mr-1",
                                          attrs: {
                                            label: _vm.$t(
                                              "customer_insights.label.brand"
                                            ),
                                            name: "id_brand",
                                            placeholder: _vm.$t(
                                              "customer_insights.label.brand"
                                            ),
                                            items: _vm.brandsList,
                                            "item-value": "id_brand",
                                            "item-text": "name",
                                            outlined: "",
                                            dense: "",
                                            rules: [
                                              _vm.mostrarBrands
                                                ? _vm.rules.name
                                                : [],
                                            ],
                                          },
                                          on: { change: _vm.changeSelects },
                                          model: {
                                            value: _vm.brand_id,
                                            callback: function ($$v) {
                                              _vm.brand_id = $$v
                                            },
                                            expression: "brand_id",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(VSelect, {
                                      staticClass: "mr-1",
                                      attrs: {
                                        label: _vm.label.year,
                                        name: "year_id",
                                        placeholder: _vm.label.year,
                                        items: _vm.yearsList,
                                        rules: _vm.rules.year,
                                        "item-value": "id",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      on: { change: _vm.changeSelects },
                                      model: {
                                        value: _vm.year_id,
                                        callback: function ($$v) {
                                          _vm.year_id = $$v
                                        },
                                        expression: "year_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(VSelect, {
                                      staticClass: "mr-1",
                                      attrs: {
                                        label: _vm.label.month,
                                        name: "month_id",
                                        placeholder: _vm.label.month,
                                        items: _vm.monthsList,
                                        rules: _vm.rules.month,
                                        "item-value": "id",
                                        "item-text": "name",
                                        outlined: "",
                                        dense: "",
                                      },
                                      on: { change: _vm.changeSelects },
                                      model: {
                                        value: _vm.month_id,
                                        callback: function ($$v) {
                                          _vm.month_id = $$v
                                        },
                                        expression: "month_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(VSelect, {
                                      attrs: {
                                        name: "id_region",
                                        label: _vm.$t(
                                          "customer_insights.label.region"
                                        ),
                                        placeholder: _vm.$t(
                                          "customer_insights.label.region"
                                        ),
                                        outlined: "",
                                        dense: "",
                                        rules: _vm.rules.region,
                                        items: _vm.regionsList,
                                        "item-value": "id_region",
                                        "item-text": "name",
                                      },
                                      on: { change: _vm.changeSelects },
                                      model: {
                                        value: _vm.region_id,
                                        callback: function ($$v) {
                                          _vm.region_id = $$v
                                        },
                                        expression: "region_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VRow,
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    [
                                      _c(
                                        VStepper,
                                        {
                                          model: {
                                            value: _vm.currentStep,
                                            callback: function ($$v) {
                                              _vm.currentStep = $$v
                                            },
                                            expression: "currentStep",
                                          },
                                        },
                                        [
                                          _c(
                                            VStepperHeader,
                                            [
                                              _c(
                                                VStepperStep,
                                                {
                                                  attrs: {
                                                    complete:
                                                      _vm.currentStep > 1,
                                                    step: "1",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customer_insights.label.visitor_step1"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(VDivider),
                                              _c(
                                                VStepperStep,
                                                {
                                                  attrs: {
                                                    complete:
                                                      _vm.currentStep > 2,
                                                    step: "2",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customer_insights.label.visitor_step2"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(VDivider),
                                              _c(
                                                VStepperStep,
                                                { attrs: { step: "3" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customer_insights.label.visitor_step3"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VStepperItems,
                                            [
                                              _c(
                                                VStepperContent,
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { step: "1" },
                                                },
                                                [
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                          attrs: { cols: "10" },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "m-0 p-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Escriba los highlights de tu organización"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: { cols: "2" },
                                                        },
                                                        [
                                                          _vm.highlights
                                                            .length < 4
                                                            ? _c(
                                                                VBtn,
                                                                {
                                                                  staticClass:
                                                                    "btn-inca-secondary",
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.highlights.push(
                                                                          ""
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(VIcon, [
                                                                    _vm._v(
                                                                      "mdi-plus"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._l(
                                                    _vm.highlights,
                                                    function (
                                                      highlight,
                                                      index
                                                    ) {
                                                      return _c(
                                                        VRow,
                                                        {
                                                          key: index,
                                                          staticClass: "mt-1",
                                                        },
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "10",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VTextField,
                                                                {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    block: "",
                                                                    "hide-details":
                                                                      "auto",
                                                                    dense: "",
                                                                    rules:
                                                                      _vm.rules
                                                                        .highlight,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .highlights[
                                                                        index
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.highlights,
                                                                          index,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "highlights[index]",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "2",
                                                              },
                                                            },
                                                            [
                                                              index > 0
                                                                ? [
                                                                    _c(
                                                                      VBtn,
                                                                      {
                                                                        staticClass:
                                                                          "btn-inca-secondary",
                                                                        attrs: {
                                                                          icon: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.highlights.splice(
                                                                                index,
                                                                                1
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          VIcon,
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-trash-can"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: {
                                                            cols: "10 text-right",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "p-0 mt-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "* Máx: 150 carácteres por highlight, Máx. 4 Hightlights"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VBtn,
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.currentStep = 2
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Continuar ")]
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                VStepperContent,
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { step: "2" },
                                                },
                                                [
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                          attrs: { cols: "10" },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "m-0 p-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Escriba los competidores de tu organización"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: { cols: "2" },
                                                        },
                                                        [
                                                          _vm.competitors
                                                            .length < 4
                                                            ? _c(
                                                                VBtn,
                                                                {
                                                                  staticClass:
                                                                    "btn-inca-secondary",
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.competitors.push(
                                                                          ""
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(VIcon, [
                                                                    _vm._v(
                                                                      "mdi-plus"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._l(
                                                    _vm.competitors,
                                                    function (
                                                      competitor,
                                                      index
                                                    ) {
                                                      return _c(
                                                        VRow,
                                                        {
                                                          key: index,
                                                          staticClass: "mt-1",
                                                        },
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "10",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VTextField,
                                                                {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    block: "",
                                                                    "hide-details":
                                                                      "auto",
                                                                    dense: "",
                                                                    rules:
                                                                      _vm.rules
                                                                        .competidores,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .competitors[
                                                                        index
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.competitors,
                                                                          index,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "competitors[index]",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "2",
                                                              },
                                                            },
                                                            [
                                                              index > 0
                                                                ? [
                                                                    _c(
                                                                      VBtn,
                                                                      {
                                                                        staticClass:
                                                                          "btn-inca-secondary",
                                                                        attrs: {
                                                                          icon: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.competitors.splice(
                                                                                index,
                                                                                1
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          VIcon,
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-trash-can"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: {
                                                            cols: "10 text-right",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "p-0 mt-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "* Máx: 45 carácteres por highlight, Máx. 4 Competidores"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VBtn,
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.currentStep = 1
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Anterior ")]
                                                  ),
                                                  _c(
                                                    VBtn,
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.currentStep = 3
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Continuar ")]
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                VStepperContent,
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { step: "3" },
                                                },
                                                [
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(VCol, {
                                                        staticClass:
                                                          "text-left",
                                                        attrs: { cols: "12" },
                                                      }),
                                                      _c(
                                                        VCol,
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                          attrs: { cols: "10" },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "m-0 p-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Agrega las métricas no ingresadas por su compañia (MKS, PDM, NPS)"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: { cols: "2" },
                                                        },
                                                        [
                                                          _vm.metrics.length < 4
                                                            ? _c(
                                                                VBtn,
                                                                {
                                                                  staticClass:
                                                                    "btn-inca-secondary",
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.metrics.push(
                                                                          {
                                                                            selectedItem:
                                                                              "",
                                                                            value:
                                                                              "",
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(VIcon, [
                                                                    _vm._v(
                                                                      "mdi-plus"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._l(
                                                    _vm.metrics,
                                                    function (metric, index) {
                                                      return _c(
                                                        VRow,
                                                        {
                                                          key: index,
                                                          staticClass: "mt-1",
                                                          attrs: {
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "4",
                                                              },
                                                            },
                                                            [
                                                              _c(VSelect, {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  items:
                                                                    _vm.metric_options,
                                                                  "item-value":
                                                                    "id",
                                                                  "item-text":
                                                                    "name",
                                                                  outlined: "",
                                                                  dense: "",
                                                                  rules: [
                                                                    _vm.rules
                                                                      .name,
                                                                    function (
                                                                      v
                                                                    ) {
                                                                      return (
                                                                        _vm.isMetricSelected(
                                                                          v,
                                                                          index
                                                                        ) ||
                                                                        "Esta métrica ya ha sido seleccionada"
                                                                      )
                                                                    },
                                                                    function (
                                                                      v
                                                                    ) {
                                                                      return (
                                                                        !!v ||
                                                                        "Este campo es requerido"
                                                                      )
                                                                    },
                                                                  ],
                                                                },
                                                                model: {
                                                                  value:
                                                                    metric.selectedItem,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        metric,
                                                                        "selectedItem",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "metric.selectedItem",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VTextField,
                                                                {
                                                                  staticClass:
                                                                    "inca-right-align",
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    block: "",
                                                                    "hide-details":
                                                                      "auto",
                                                                    dense: "",
                                                                    rules:
                                                                      metric.selectedItem ===
                                                                      2
                                                                        ? [
                                                                            _vm
                                                                              .rules
                                                                              .numericRules ||
                                                                              "Ingrese solo números",
                                                                          ]
                                                                        : [
                                                                            _vm
                                                                              .rules
                                                                              .percentages,
                                                                            function (
                                                                              v
                                                                            ) {
                                                                              return (
                                                                                /^[0-9]+(\.[0-9]+)?%$/.test(
                                                                                  v
                                                                                ) ||
                                                                                "Ingrese un valor válido en formato porcentual"
                                                                              )
                                                                            },
                                                                          ],
                                                                    maxlength:
                                                                      "4",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      metric.value,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          metric,
                                                                          "value",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "metric.value",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VCol,
                                                            {
                                                              attrs: {
                                                                cols: "2",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VBtn,
                                                                {
                                                                  staticClass:
                                                                    "btn-inca-secondary",
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.metrics.splice(
                                                                          index,
                                                                          1
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(VIcon, [
                                                                    _vm._v(
                                                                      "mdi-trash-can"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _c(
                                                    VRow,
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: { cols: "10" },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "p-0 mt-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "* Si el usuario agrega 2 o+ métricas iguales, el proceso de ingreso será inválido"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "justify-end",
                                                    },
                                                    [
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.currentStep = 2
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" Anterior ")]
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: _vm.onSubmit,
                                                          },
                                                        },
                                                        [_vm._v(" Grabar ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }